import { Typography } from 'seagull';
import { AnchorIcon } from 'seagull/icons';
import styles from "./MapAccountsModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const columnDefs = [{
  width: 400
},
// Anchor account
{
  width: 400
},
// QuickBooks account
{
  width: 260
} // Status
];
export const headerItems = [{
  value: /*#__PURE__*/_jsxs("div", {
    className: styles.columnHeader,
    children: [/*#__PURE__*/_jsx(AnchorIcon, {
      className: styles.icon
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      children: "Account type"
    })]
  })
}, {
  value: /*#__PURE__*/_jsx("div", {
    className: styles.columnHeader,
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      children: "Account name"
    })
  })
}, {
  value: 'Status'
}];